var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.roomInfo && _vm.show)?_c('div',{staticClass:"live-ing"},[_c('div',{staticClass:"live-ing-title"},[_vm._v(_vm._s(_vm.roomInfo.name))]),_c('div',{staticClass:"live-ing-txt"},[_vm._v("直播倒计时")]),_c('div',{staticClass:"live-ing-count"},[_vm._v(_vm._s(_vm.txt))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }